import React from "react";
import PropTypes from "prop-types";

import styles from "./Parchment.module.css";

function Parchment({ className, children, ...other }) {
  return (
    <div
      className={styles.parchment + " " + className}
      {...other}
      style={{ backgroundImage: "url(/images/pet-creation/Parchment3.png)" }}
    >
      {children}
    </div>
  );
}

Parchment.propTypes = {
  className: PropTypes.string,
};

export default Parchment;
